import { render, staticRenderFns } from "./OptInSuccess.vue?vue&type=template&id=c5f196ac&scoped=true"
import script from "./OptInSuccess.vue?vue&type=script&lang=js"
export * from "./OptInSuccess.vue?vue&type=script&lang=js"
import style0 from "./OptInSuccess.vue?vue&type=style&index=0&id=c5f196ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f196ac",
  null
  
)

export default component.exports